import { useState, useEffect } from "react";
import { Frame, Loading, Header, Input, ValidaUid } from "../components";
import { useNavigate } from "react-router-dom";
import { ValidaForm3 } from "../components/Validacao";
import { db, auth, storage } from "../config/firebase";
import { doc, getDoc, setDoc } from "firebase/firestore";
import { ref, getDownloadURL, uploadBytesResumable } from "firebase/storage";
import { Row, Col, Button } from "react-bootstrap";

const Form3 = () => {
  const [erro, setErro] = useState({});
  const [dados, setDados] = useState({});
  const [loading, setLoading] = useState(true);

  let uid = auth.currentUser?.uid;

  const navigate = useNavigate();

  const uploadFile = async (file, docPath, docUrl) => {
    if (!file) return;

    setLoading(true);

    const path = ref(storage, `cangucu2026/${uid}/${docPath}`);

    const upload = uploadBytesResumable(path, file, file.type);

    upload.on(
      "state_changed",
      () => {},
      () => {},
      () => {
        getDownloadURL(upload.snapshot.ref).then((url) => {
          setDados({ ...dados, [docUrl]: url });
          setLoading(false);
        });
      },
    );
  };

  const setData = async () => {
    await setDoc(doc(db, "cangucu2026", uid), dados, { merge: true });
  };

  const handleSubmit = (e) => {
    e.preventDefault();

    setLoading(true);

    const err = ValidaForm3(dados);

    if (err) {
      setErro(err);
      setLoading(false);
    } else {
      setData().then(() => navigate("../form4"));
    }
  };

  const buscaDados = async () => {
    const uid = await ValidaUid();

    if (uid) {
      const qry = await getDoc(doc(db, "cangucu2026", uid));

      const data = qry.data();

      if (!data?.status) {
        setLoading(false);
        setDados(data);
      } else {
        navigate("../home");
      }
    }
  };

  useEffect(() => {
    buscaDados();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return (
    <>
      {loading && <Loading />}
      <Header nome={dados?.nome} foto={dados?.urlFoto} />
      <Frame
        body={
          <form
            autoComplete="off"
            onSubmit={handleSubmit}
            className="text-start"
            noValidate
          >
            <Row className="mt-2">
              <Col>
                <Input
                  id="imgRg"
                  label="RG"
                  type="file"
                  url={dados?.urlRg}
                  accept=".jpg, .jpeg, .png, .pdf"
                  className={erro.rg && "is-invalid"}
                  onChange={(e) => uploadFile(e.target.files[0], "rg", "urlRg")}
                  erro={erro.rg}
                />
              </Col>
            </Row>
            {dados?.menor && (
              <Row className="mt-2">
                <Col>
                  <Input
                    id="imgRgResponsavel"
                    label="RG do Responsável"
                    type="file"
                    url={dados?.urlRgResponsavel}
                    accept=".jpg, .jpeg, .png, .pdf"
                    className={erro.rgResponsavel && "is-invalid"}
                    onChange={(e) =>
                      uploadFile(
                        e.target.files[0],
                        "rgResponsavel",
                        "urlRgResponsavel",
                      )
                    }
                    erro={erro.rg}
                  />
                </Col>
              </Row>
            )}
            <Row className="mt-2">
              <Col>
                <Input
                  id="imgVinculo"
                  label="Comprovante de Vínculo"
                  type="file"
                  accept=".jpg, .jpeg, .png, .pdf"
                  url={dados?.urlVinculo}
                  className={erro.vinculo && "is-invalid"}
                  onChange={(e) =>
                    uploadFile(e.target.files[0], "vinculo", "urlVinculo")
                  }
                  erro={erro.vinculo}
                />
              </Col>
            </Row>
            <Row className="mt-2">
              <Col>
                <Input
                  id="imgResidencia"
                  label="Comprovante de Residência"
                  type="file"
                  url={dados?.urlResidencia}
                  accept=".jpg, .jpeg, .png, .pdf"
                  className={erro.residencia && "is-invalid"}
                  onChange={(e) =>
                    uploadFile(e.target.files[0], "residencia", "urlResidencia")
                  }
                  erro={erro.residencia}
                />
              </Col>
            </Row>
            <Row className="mt-4">
              <Col className="d-grid">
                <Button variant="primary" type="submit">
                  {" "}
                  ENVIAR{" "}
                </Button>
              </Col>
            </Row>
          </form>
        }
        title="Documentos"
      />
    </>
  );
};

export default Form3;
